import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAQvgLbmkYq2H7w_oYyMppeKbX8slvsrIw",
  authDomain: "websitegame-7b309.firebaseapp.com",
  projectId: "websitegame-7b309",
  storageBucket: "websitegame-7b309.firebasestorage.app",
  messagingSenderId: "264308085066",
  appId: "1:264308085066:web:f9622b9d6a7fbc917a31b3",
  measurementId: "G-TZCDT28GTL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);